import { toString, toNumber } from 'lodash';
import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const CHANGE_CREATE_PHARMACY_CONFIGURATION_FORM = '@PHARMACY/CHANGE_CREATE_PHARMACY_CONFIGURATION_FORM';
export const CLEAR_CREATE_PHARMACY_CONFIGURATION_FORM = '@PHARMACY/CLEAR_CREATE_PHARMACY_CONFIGURATION_FORM';

export const GET_PHARMACY_CONFIGURATION = '@PHARMACY/GET_PHARMACY_CONFIGURATION';
export const GET_PHARMACY_CONFIGURATION_SUCCESS = '@PHARMACY/GET_PHARMACY_CONFIGURATION_SUCCESS';
export const GET_PHARMACY_CONFIGURATION_FAIL = '@PHARMACY/GET_PHARMACY_CONFIGURATION_FAIL';

export const UPDATE_PHARMACY_CONFIGURATION = '@PHARMACY/UPDATE_PHARMACY_CONFIGURATION';
export const UPDATE_PHARMACY_CONFIGURATION_SUCCESS = '@PHARMACY/UPDATE_PHARMACY_CONFIGURATION_SUCCESS';
export const UPDATE_PHARMACY_CONFIGURATION_FAIL = '@PHARMACY/UPDATE_PHARMACY_CONFIGURATION_FAIL';

export const CONFIG_READONLY_PHARMACY = '@PHARMACY/CONFIG_READONLY_PHARMACY';
export const CONFIG_READONLY_PHARMACY_SUCCESS = '@PHARMACY/CONFIG_READONLY_PHARMACY_SUCCESS';
export const CONFIG_READONLY_PHARMACY_FAIL = '@PHARMACY/CONFIG_READONLY_PHARMACY_FAIL';

export const CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY = '@PHARMACY/CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY';
export const CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_SUCCESS = '@PHARMACY/CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_SUCCESS';
export const CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_FAIL = '@PHARMACY/CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_FAIL';

export const CHANGE_PHARMACY_CONFIGURATION_FORM = '@PHARMACY/CHANGE_PHARMACY_CONFIGURATION_FORM';

export const CLEAR_PHARMACY_CONFIGURATION_FORM = '@PHARMACY/CLEAR_PHARMACY_CONFIGURATION_FORM';

export const GET_DEFAULT_DISPENSE_CONFIGURATION = '@PHARMACY/GET_DEFAULT_DISPENSE_CONFIGURATION';
export const GET_DEFAULT_DISPENSE_CONFIGURATION_SUCCESS = '@PHARMACY/GET_DEFAULT_DISPENSE_CONFIGURATION_SUCCESS';
export const GET_DEFAULT_DISPENSE_CONFIGURATION_FAIL = '@PHARMACY/GET_DEFAULT_DISPENSE_CONFIGURATION_FAIL';

export function getPharmacyConfiguration(pharmacyId) {
  return (dispatch) => {
    dispatch({ type: GET_PHARMACY_CONFIGURATION });
    Promise.all([
      HttpService.get(`/api/pharmacies/${pharmacyId}/configuration`),
      HttpService.get(`/api/pharmacies/${pharmacyId}/collapse-menu-bar`),
    ])
      .then(([resp, collapseResp]) => {
        dispatch({
          type: GET_PHARMACY_CONFIGURATION_SUCCESS,
          payload: {
            id: pharmacyId,
            data: parseModelToData({
              ...resp.data,
              collapseMenuBar: collapseResp?.data?.isCollapseMenuBar,
            }),
          },
        });
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({
          type: GET_PHARMACY_CONFIGURATION_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
}

export function updatePharmacyConfiguration() {
  return (dispatch, getState) => {
    const { data, id } = getState().pharmacy.update.configuration;
    dispatch({ type: UPDATE_PHARMACY_CONFIGURATION });
    Promise.all([
      HttpService.put(`/api/pharmacies/${id}/configuration`, parseDataToModel(data)),
      HttpService.put(`/api/pharmacies/${id}/collapse-menu-bar`, {
        isCollapseMenuBar: data.collapseMenuBar === 'true',
      }),
    ])
      .then(() => {
        const { currentPharmacyId } = getState().auth.user.data;
        if (toString(id) === toString(currentPharmacyId)) {
          dispatch(AppActions.applyCollapseNavbar(data.collapseMenuBar === 'true'));
        }
        dispatch(
          AppActions.showMessage({
            message: 'pharmacy:UPDATE_PHARMACY_CONFIGURATION_SUCCESS',
            autoHideDuration: 4000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          }),
        );
        dispatch({ type: UPDATE_PHARMACY_CONFIGURATION_SUCCESS });
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({
          type: UPDATE_PHARMACY_CONFIGURATION_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
}

export function changePharmacyConfigurationForm(data) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PHARMACY_CONFIGURATION_FORM, payload: { data } });
  };
}

export function clearUpdateConfigurationForm() {
  return (dispatch) => {
    dispatch({ type: CLEAR_PHARMACY_CONFIGURATION_FORM });
  };
}

export function getDefaultDispenseConfiguration() {
  return (dispatch) => {
    dispatch({ type: GET_DEFAULT_DISPENSE_CONFIGURATION });
    HttpService.get('api/pharmacies/default-dispense-configuration')
      .then((resp) => {
        const payloadData = parseDefaultDispenseConfig(resp.data || {});
        dispatch({ type: GET_DEFAULT_DISPENSE_CONFIGURATION_SUCCESS, payload: { data: payloadData } });
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: GET_DEFAULT_DISPENSE_CONFIGURATION_FAIL, payload: { message: errorMessages.join('\n') } });
        if (errorMessages?.length) {
          dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
        }
      });
  };
}

export const configReadOnlyMode = (pharmacyId, enable) => {
  return (dispatch) => {
    dispatch({ type: CONFIG_READONLY_PHARMACY });
    return HttpService.put(`/api/pharmacies/${pharmacyId}/configuration-readonly-mode?enable=${enable}`)
      .then(() => {
        dispatch(AppActions.showMessage({ message: 'pharmacy:READONLY_MODE_SUCCESS' }));
        dispatch({ type: CONFIG_READONLY_PHARMACY_SUCCESS, payload: { readOnlyMode: enable } });
        return true;
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: CONFIG_READONLY_PHARMACY_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const configMypakSyncIntegration = (pharmacyId, enable) => {
  return (dispatch) => {
    dispatch({ type: CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY });
    return HttpService.put(`/api/pharmacies/${pharmacyId}/configuration-mypak-integration?enable=${enable}`)
      .then(() => {
        dispatch(AppActions.showMessage({ message: 'pharmacy:MYPAK_INTEGRATION_SUCCESS' }));
        dispatch({
          type: CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_SUCCESS,
          payload: { isMypakSyncIntegrationEnabled: enable },
        });
        return true;
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

function parseModelToData(model) {
  return {
    dispensingSystem: toString(model.dispensingSystem),
    fredPakStatusActive: toString(model.fredPakStatusActive),
    minfosServerURL: model.minfosServerURL,
    minfosUserName: model.minfosUserName,
    minfosPassword: model.minfosPassword,
    minfosBusinessCode: model.minfosBusinessCode,
    lotsSQLHost: model.lotsSQLHost,
    lotsSQLDatabase: model.lotsSQLDatabase,
    lotsSQLUserName: model.lotsSQLUserName,
    lotsSQLPassword: model.lotsSQLPassword,
    zsqlHost: model.zsqlHost,
    zsqlDatabase: model.zsqlDatabase,
    zsqlUserName: model.zsqlUserName,
    zsqlPassword: model.zsqlPassword,
    corumClearConnectPath: model.corumClearConnectPath,
    corumClearIdentifier: model.corumClearIdentifier,
    fredDataBaseFolder: model.fredDataBaseFolder,
    pathForDORPTS: model.pathForDORPTS,
    fredPakPath: model.fredPakPath,
    pharmacyGuid: model.pharmacyGuid,
    syncCollection: model.syncCollection,
    maxDaysToCheckScript: model.maxDaysToCheckScript || 0,
    alpacaFileExportFolder: model.alpacaFileExportFolder || '',
    packJobPrinting: model.packJobPrinting || false,
    packJobPacking: model.packJobPacking || false,
    packJobChecking: model.packJobChecking || false,
    packJobDistribution: model.packJobDistribution || false,
    packManagementDateCreatedFilter: model.packManagementDateCreatedFilter,
    zapiServiceURL: model.zapiServiceURL,
    zapiVendorAccessKey: model.zapiVendorAccessKey,
    zapiStoreAccessKey: model.zapiStoreAccessKey,
    zapiUserName: model.zapiUserName,
    zapiBatchId: model.zapiBatchId,
    fredNXTAPIURL: model.fredNXTAPIURL,
    fredNXTAccessKey: model.fredNXTAccessKey,
    fredNXTSubscriptionKey: model.fredNXTSubscriptionKey,
    enableQScript: toString(model.enableQScript),
    enableVPB: toString(model.enableVPB),
    enableVPBHistorySummary: toString(model.enableVPBHistorySummary === true),
    displayVPBInCheckingPhrase: toString(model.displayVPBInCheckingPhrase),
    enableDispenseTracker: toString(model.enableDispenseTracker),
    isMypakSyncIntegrationEnabled: toString(model.isMypakSyncIntegrationEnabled),
    isDoseAdd: toString(model.isDoseAdd),
    isIntegrator: toString(model.isIntegrator),
    integratorGuids: model.integratorGuids,
    dwDatabase: model.dwDatabase,
    dwHost: model.dwHost,
    dwTrustedConnection: model.dwTrustedConnection,
    dwUserName: model.dwUserName,
    dwPassword: model.dwPassword,
    dwqScriptExportFolder: model.dwqScriptExportFolder,
    daysImportNewDrugsDispensed: model.daysImportNewDrugsDispensed,
    fredDispensePlusApiKey: model.fredDispensePlusApiKey,
    fredDispensePlusURL: model.fredDispensePlusURL,
    fredDispensePlusSubscriptionKey: model.fredDispensePlusSubscriptionKey,
    logoutInactivityTime: model.logoutInactivityTime,
    sqsAlpacaQueueName: model.sqsAlpacaQueueName,
    collapseMenuBar: toString(model.collapseMenuBar),
    useGlobalDrug: toString(model.useGlobalDrug),
    brandSwapProfileChangeAlert: toString(model.brandSwapProfileChangeAlert !== false),
    readOnlyMode: model.readOnlyMode || false,
  };
}

function parseDataToModel(data) {
  return {
    dispensingSystem: toNumber(data.dispensingSystem),
    fredPakStatusActive: data.fredPakStatusActive === 'true',
    minfosServerURL: data.minfosServerURL,
    minfosUserName: data.minfosUserName,
    minfosPassword: data.minfosPassword,
    minfosBusinessCode: data.minfosBusinessCode,
    lotsSQLHost: data.lotsSQLHost,
    lotsSQLDatabase: data.lotsSQLDatabase,
    lotsSQLUserName: data.lotsSQLUserName,
    lotsSQLPassword: data.lotsSQLPassword,
    zsqlHost: data.zsqlHost,
    zsqlDatabase: data.zsqlDatabase,
    zsqlUserName: data.zsqlUserName,
    zsqlPassword: data.zsqlPassword,
    corumClearConnectPath: data.corumClearConnectPath,
    corumClearIdentifier: data.corumClearIdentifier,
    fredDataBaseFolder: data.fredDataBaseFolder,
    pathForDORPTS: data.pathForDORPTS,
    fredPakPath: data.fredPakPath,
    pharmacyGuid: data.pharmacyGuid,
    syncCollection: data.syncCollection,
    maxDaysToCheckScript: data.maxDaysToCheckScript || 0,
    alpacaFileExportFolder: data.alpacaFileExportFolder || '',
    packJobPrinting: data.packJobPrinting || false,
    packJobPacking: data.packJobPacking || false,
    packJobChecking: data.packJobChecking || false,
    packJobDistribution: data.packJobDistribution || false,
    packManagementDateCreatedFilter: data.packManagementDateCreatedFilter,
    zapiServiceURL: data.zapiServiceURL,
    zapiVendorAccessKey: data.zapiVendorAccessKey,
    zapiStoreAccessKey: data.zapiStoreAccessKey,
    zapiUserName: data.zapiUserName,
    zapiBatchId: data.zapiBatchId,
    fredNXTAPIURL: data.fredNXTAPIURL,
    fredNXTAccessKey: data.fredNXTAccessKey,
    fredNXTSubscriptionKey: data.fredNXTSubscriptionKey,
    enableQScript: data.enableQScript === 'true',
    enableVPB: data.enableVPB === 'true',
    displayVPBInCheckingPhrase: data.displayVPBInCheckingPhrase === 'true',
    enableDispenseTracker: data.enableDispenseTracker === 'true',
    isMypakSyncIntegrationEnabled: data.isMypakSyncIntegrationEnabled === 'true',
    isDoseAdd: data.isDoseAdd === 'true',
    isIntegrator: data.isIntegrator === 'true',
    integratorGuids: data.integratorGuids,
    dwDatabase: data.dwDatabase,
    dwHost: data.dwHost,
    dwTrustedConnection: data.dwTrustedConnection || false,
    dwUserName: data.dwUserName,
    dwPassword: data.dwPassword,
    dwqScriptExportFolder: data.dwqScriptExportFolder,
    daysImportNewDrugsDispensed: data.daysImportNewDrugsDispensed,
    fredDispensePlusApiKey: data.fredDispensePlusApiKey,
    fredDispensePlusURL: data.fredDispensePlusURL,
    fredDispensePlusSubscriptionKey: data.fredDispensePlusSubscriptionKey,
    logoutInactivityTime: data.logoutInactivityTime,
    sqsAlpacaQueueName: data.sqsAlpacaQueueName,
    useGlobalDrug: data.useGlobalDrug === 'true',
    brandSwapProfileChangeAlert: data.brandSwapProfileChangeAlert !== 'false',
    readOnlyMode: data.readOnlyMode || false,
  };
}

function parseDefaultDispenseConfig(model) {
  const fredDefaults = model.fred || {};
  const minfosDefaults = model.minfos || {};
  const zDefaults = model.z || {};
  const dispenseWorksDefaults = model.dispenseWorks || {};
  const fredDispensePlusDefaults = model.fredDispensePlus || {};

  return {
    0: {
      fredDataBaseFolder: fredDefaults.fredDbfsFolder || '',
      pathForDORPTS: fredDefaults.fredDorptsPath || '',
    },
    9: {
      minfosServerURL: minfosDefaults.minfosWebServiceUrl || '',
      minfosUserName: minfosDefaults.minfosUsername || '',
      minfosPassword: minfosDefaults.minfosPassword || '',
    },
    5: {
      zapiServiceURL: zDefaults.zApiUrl || '',
      zapiVendorAccessKey: zDefaults.zVendorAccessKey || '',
      zapiStoreAccessKey: zDefaults.zStoreAccessKey || '',
      zapiUserName: zDefaults.zUsername || '',
      zapiBatchId: zDefaults.zBatchId || '',
    },
    12: {
      dwDatabase: dispenseWorksDefaults.dispenseWorksDatabase || '',
      dwUserName: dispenseWorksDefaults.dispenseWorksUsername || '',
      dwPassword: dispenseWorksDefaults.dispenseWorksPassword || '',
      dwHost: dispenseWorksDefaults.dispenseWorksHost || '',
    },
    13: {
      fredDispensePlusURL: fredDispensePlusDefaults.fredPlusApiUrl || '',
      fredDispensePlusSubscriptionKey: fredDispensePlusDefaults.fredPlusSubscriptionKey || '',
      fredDispensePlusApiKey: fredDispensePlusDefaults.fredPlusApiKey || '',
    },
  };
}
